import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFolders16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconFolders16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M7.197 1c.502 0 .97.25 1.248.668L9.333 3H13a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2v1a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V5.5A1.5 1.5 0 0 1 2.5 4H3V2.5A1.5 1.5 0 0 1 4.5 1zM2 13a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H2zm3.197-9c.502 0 .97.25 1.248.668L7.333 6H11a2 2 0 0 1 2 2v3a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zM2.5 5a.5.5 0 0 0-.5.5V6h4.132l-.519-.777A.5.5 0 0 0 5.197 5zm2-3a.5.5 0 0 0-.5.5V3h4.132l-.519-.777A.5.5 0 0 0 7.197 2z"
            />
        </svg>
    );
}
export default memo(IconFolders16);
